import React from 'react';
import './App.css';
import { CollectData } from "./components/CollectData";

function App() {
    return (
        <CollectData />
  );
}

export default App;